import request from 'superagent'
import { useMutation } from 'react-query'
import { getApiServer } from '../../utils/domain'
import { CustomHttpError } from '../../types/CustomHttpError'

export default function useRegisterApp(csrfToken: string) {
  return useMutation(
    (values: any) => request
      .post(`${getApiServer()}/developer/register`)
      .set('Accept', 'application/json')
      .set('X-CSRF-Token', csrfToken)
      .send(values)
      .withCredentials()
      .then((res) => res.body),
    {
      onError: (error: CustomHttpError) => {
        return error?.response?.text ?? error.message
      }
    }
  )
}